<script lang="ts" setup>
const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
})

const { filter } = toRefs(props)

defineEmits(['input', 'filter-reset', 'filter-apply'])
</script>

<template>
  <div class="filter-range">
    <div class="filter-range__panel">
      <div class="filter-range__min">
        <label
          :for="filter.key + '_min'"
          class="filter-range__label"
        >
          {{ $t('From') }} €
        </label>
        <input
          :id="filter.key + '_min'"
          v-model="filter.minToBeSelected"
          data-model="minValue"
          type="number"
          :min="Math.floor(parseFloat(filter.min))"
          :max="Math.ceil(parseFloat(filter.max))"
          class="filter-range__input"
          @input="$emit('input')"
          @focusout="$emit('input')"
          @keyup.enter="$emit('filter-apply')"
        >
      </div>
      <div class="filter-range__max">
        <label
          :for="filter.key + '_max'"
          class="filter-range__label"
        >
          {{ $t('to') }}
        </label>
        <input
          :id="filter.key + '_max'"
          v-model="filter.maxToBeSelected"
          data-model="maxValue"
          type="number"
          :min="Math.floor(parseFloat(filter.min))"
          :max="Math.ceil(parseFloat(filter.max))"
          class="filter-range__input"
          @input="$emit('input')"
          @focusout="$emit('input')"
          @keyup.enter="$emit('filter-apply')"
        >
      </div>
    </div>

    <div class="filter-range__buttons">
      <button
        type="button"
        class="filter-range__apply"
        @click="$emit('filter-apply')"
      >
        {{ $t('Apply') }}
      </button>
      <button
        type="button"
        class="filter-range__reset"
        @click="$emit('filter-reset')"
      >
        {{ $t('Reset') }}
      </button>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/Filter/Range.css");
</style>
